import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { BetaProvider } from './contexts/BetaContext';
import { BetaDataProvider } from './contexts/BetaDataContext';
import { ToastProvider } from './components/common/Toast';
import { ConfirmDialogProvider } from './components/common/ConfirmDialog';
import { ModalProvider } from './contexts/ModalContext';
import { FilterProvider } from './contexts/FilterContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import MainLayout from './components/layout/MainLayout';
import UpdatePrompt from './components/common/UpdatePrompt';
import './App.scss';

function App() {
  return (
    <>
      <UpdatePrompt />
      <AuthProvider>
          <BetaProvider>
            <BetaDataProvider>
              <ModalProvider>
              <FilterProvider>
                <ConfirmDialogProvider>
                  <ToastProvider>
                  <Router basename="/project">
                    <Routes>
                      {/* 主要應用程式路由（需要登入） */}
                      <Route
                        path="/*"
                        element={
                          <ProtectedRoute>
                            <MainLayout />
                          </ProtectedRoute>
                        }
                      />
                    </Routes>
                  </Router>
                  </ToastProvider>
                </ConfirmDialogProvider>
              </FilterProvider>
              </ModalProvider>
            </BetaDataProvider>
          </BetaProvider>
      </AuthProvider>
    </>
  );
}

export default App;
